import React from 'react';
import styled from 'styled-components';

// Enhanced AestheticSpan with dynamic sizing based on context
const AestheticSpan = styled.span`
    white-space: nowrap; // Prevent wrapping
    display: inline-block;
    font-family: inherit;
    letter-spacing: 0.1em;

    // Responsive sizing approach
    @media (max-width: 850px) {
        // Use vw units for the middle value in clamp to scale with viewport
        // Scale the min and max values with the current font size using 'em'
        // This way it works for both body text and titles
        font-size: clamp(0.7em, 3vw, 1em);
        letter-spacing: 0.05em;
    }

    @media (max-width: 600px) {
        font-size: clamp(0.5em, 2.5vw, 0.8em);
        letter-spacing: 0.03em;
    }

    @media (max-width: 450px) {
        font-size: clamp(0.3em, 2.2vw, 0.8em);
        letter-spacing: 0.0em; // Further reduce letter spacing
    }
`;

const AestheticText = ({ children, ...props }) => {
    return (
        <AestheticSpan {...props}>
            {children}
        </AestheticSpan>
    );
};

export default AestheticText;